import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import * as analytics from 'analytics/Analytics';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import EnzymeList, {EnzymeListCollection} from 'molbio/enzymes/backbone/EnzymeList';
import Enzymes from 'molbio/enzymes/backbone/Enzymes';
import EnzymeListEditor from 'molbio/enzymes/EnzymeListEditor';
import notifications from 'notifications';
import OwnablesManageView, {OwnablesManageViewOptions} from 'profile/OwnablesManageView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import {BasicEvent} from 'util/Types';

let enzymeListsCollection: EnzymeListCollection | null = null;

class EnzymeListsView extends OwnablesManageView<EnzymeList> {
  type!: string;
  modelType!: string;
  enzymes!: Enzymes;
  ownables!: EnzymeListCollection;

  static initClass(): void {
    this.prototype.el = '.js-enzyme-lists';
    this.prototype.type = 'enzyme-lists';
    this.prototype.modelType = ModelTypeConstants.ENZYME_LIST;
  }

  override events(): Backbone.EventsHash {
    return {
      ...super.events(),
      'submit .create-new form': 'createNewList',
    };
  }

  static getBootstrappedOwnables(): EnzymeListCollection {
    if (enzymeListsCollection == null) {
      enzymeListsCollection = new EnzymeListCollection(window.bootstrap!.enzyme_lists, {parse: true});
    }
    return enzymeListsCollection;
  }

  override initialize(options: OwnablesManageViewOptions<EnzymeList>): void {
    this.enzymes = Enzymes.getCommonEnzymes();
    super.initialize(options);
  }

  override die(): void {
    const editorNode = this.el.querySelector('.enzyme-list-editor');
    if (editorNode != null) {
      ReactDOM.unmountComponentAtNode(editorNode);
    }
    super.die();
  }

  saveEnzymesForReact(selectedEnzymeIds: Array<number>): Promise<void> {
    return new Promise((resolve) => {
      this.currentOwnable
        .save({members: selectedEnzymeIds}, {patch: true, url: `${this.currentOwnable.url()}/attributes`})
        .done(() => {
          notifications.success('Enzyme list successfully updated.');
          resolve();
        })
        .fail((error: Response) => {
          notifications.notifyError(error);
          // We have already notified the user of the error, so we resolve here.
          resolve();
        });
    });
  }

  createNewList(e: BasicEvent): void {
    e.preventDefault();
    const list = new EnzymeList({
      name: this.$el.find('.create-new .name').val(),
      description: this.$el.find('.create-new .description').val(),
      owner_id: window.bootstrap!.current_entity_id,
    });
    list
      .save()
      .done(() => {
        this.$el.find('.create-new .name, .create-new .description').val('');
        this.ownables.add(list);
        this.navigateToOwnable(list.id);
        notifications.success('List created successfully!');
        analytics.track('DATA_MANAGEMENT', 'created_ownable', {
          type: this.type,
          name: list.get('name'),
          has_description: list.get('description').length > 0,
        });
      })
      .fail(notifications.notifyError);
  }

  override renderOwnable(): void {
    super.renderOwnable();
    const list = this.currentOwnable;
    const {writable} = list.get('permissions');

    const selectedEnzymeIds: Array<number> = list.get('members').map((enzyme) => enzyme.id);
    const enzymes = this.enzymes.models.map((enzyme) => ({
      id: enzyme.id as number,
      name: enzyme.get('name'),
    }));

    renderToDOM(
      <EnzymeListEditor
        key={list.id}
        enzymes={enzymes}
        selectedEnzymeIds={selectedEnzymeIds}
        isReadOnly={!writable}
        onSave={async (newSelectedIds) => {
          await this.saveEnzymesForReact(newSelectedIds);
        }}
      />,
      this.el.querySelector('.enzyme-list-editor')
    );

    $.getJSON(`/1/api/enzyme-lists/${list.id}/collaborators/`)
      .done((res) => {
        this.createCollaboratorsView(res);
      })
      .fail(notifications.notifyError);
  }
}
EnzymeListsView.initClass();

export default EnzymeListsView;
